(function () {
  function animateBars(root) {
    const widgets = root.querySelectorAll(".promo-progress");
    widgets.forEach((w) => {
      const fill = w.querySelector(".promo-progress__bar-fill");
      if (!fill) return;

      const target = parseFloat(w.dataset.progress || "0");

      // reset + anima
      fill.style.width = "0%";
      requestAnimationFrame(() => {
        fill.style.width = target + "%";
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => animateBars(document));

  // quando Shopify recarrega seção
  document.addEventListener("shopify:section:load", (e) => {
    animateBars(e.target || document);
  });

  // fallback: detecta DOM novo no drawer
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(".promo-progress") || node.querySelector?.(".promo-progress")) {
          animateBars(node);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
